import React from 'react';
import PropTypes from 'prop-types';

import Table from '@appComponents/Table';

import {rowRenderer} from './ReportTable/reportTableRowRenderer';
import {columns} from './ReportTable/reportTableColumns';

export const ReportTable = ({eventId, reportsData, loading}) => {
    return (
        <div className='--table'>
            <Table
                name='reportTable'
                loading={loading}
                data={reportsData}
                noDataText='No reports found'
                columns={columns}
                rowRenderer={(column, row) => rowRenderer(eventId, column, row)}
                pagination={false}
            />
        </div>
    );
};

ReportTable.propTypes = {
    eventId: PropTypes.number.isRequired,
    reportsData: PropTypes.array,
    loading: PropTypes.bool,
};
